import moment from 'moment/moment';
import {
  // 单榜单筛选器
  SINGLE_SOURCE_SELECT_EXTEND_TYPE,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  STORERANK_DETAIL_PLATFORMS_OPTIONS_PC,
  STORERANK_DETAIL_PLATFORMS_OPTIONS_CONSOLE,
  getPCConsoleTopsOptionsNewValueMapping,
} from '@/pages/intelligence/_config/storeRank/utils';
import {
  PC_PLATFORMS,
  PC_STORE_RANK_TOPS_MAPPING,
  PC_TOP_TOP_SELLERS,
} from '@/pages/intelligence/_config/storeRank/config';

/**
 * 判断每一个date是否有效（配置的props名字disabledDate 语意刚好是相反的）
 * 这里是禁用当天以后的日期
 * @param date Moment日期对象
 * @return 当前date是否有效
 */
const isValidDate = (date: moment.Moment): boolean => {
  if (!date?.isValid()) return true;
  return date?.isSameOrBefore(moment(), 'day');
};

const PLATFORMS_TOPS_OPTIONS_MAPPING_PC = getPCConsoleTopsOptionsNewValueMapping('pc');
const PLATFORMS_TOPS_OPTIONS_MAPPING_CONSOLE = getPCConsoleTopsOptionsNewValueMapping('console');
const INITIAL_PLATFORM = PC_PLATFORMS[0];
const INITIAL_SHOP = PC_STORE_RANK_TOPS_MAPPING?.[INITIAL_PLATFORM]?.[0] ?? PC_TOP_TOP_SELLERS;

// 筛选器value默认值-combine-RankTrend
export const DEFAULTFILTERVALUE_COMBINE_RANKTREND = {
  [filterKeyMap.STORERANK_SEGEMENT]: {
    value: 'rank',
  },
  [filterKeyMap.RANGE_TIME]: {
    type: 'date',
    value: ['', ''],
  },
  [filterKeyMap.COMPOSED_SELECT]: {
    value: {
      parent: STORERANK_DETAIL_PLATFORMS_OPTIONS_PC?.[0].value,
      child: INITIAL_SHOP,
    },
  },
  [filterKeyMap.REGION]: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
  [filterKeyMap.COMPOSED_COUNTRY_SELECT]: {
    value: {
      type: 'multiple',
      countries: [],
    },
  },
};

// 筛选器自定义布局列表-combine-RankTrend
export const FILTERKEYLIST_COMBINE_RANKTREND = [
  filterKeyMap.STORERANK_SEGEMENT,
  filterKeyMap.RANGE_TIME,
  filterKeyMap.COMPOSED_SELECT,
  filterKeyMap.REGION,
  filterKeyMap.TIPICON,
  filterKeyMap.COMPOSED_COUNTRY_SELECT,
];

// 筛选器list配置-combine-RankTrend
export const DEFAULTINPUTLIST_COMBINE_RANKTREND = [
  {
    savePopupVisble: 1,
    key: filterKeyMap.STORERANK_SEGEMENT,
    default: 'rank',
    value: '',
  },
  {
    savePopupVisble: 1,
    visible: 1,
    key: filterKeyMap.RANGE_TIME,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    showSelectType: false,
    showShortcut: true,
    startOfWeek: 1,
    hiddenHeaderBtns: ['Latest Data', 'All of time'],
    extendFilterType: filterKeyMap.RANGE_TIME_EXTEND_TYPE_VALUE.Date,
  },
  {
    savePopupVisble: 1,
    key: filterKeyMap.COMPOSED_SELECT,
    filterKeyType: 'composed_select_combine_detail_storerank',
    visible: 1,
    isTranslate: true,
    isOnlyParent: true,
    parentOptions: [
      ...STORERANK_DETAIL_PLATFORMS_OPTIONS_PC,
      ...STORERANK_DETAIL_PLATFORMS_OPTIONS_CONSOLE,
    ],
    childOptionsMap: {
      ...PLATFORMS_TOPS_OPTIONS_MAPPING_PC,
      ...PLATFORMS_TOPS_OPTIONS_MAPPING_CONSOLE,
    },
  },
  {
    savePopupVisble: 1,
    key: filterKeyMap.REGION,
    default: [],
    visibleinlist: 1,
    hasInfoIcon: false,
    globalInfoKey: 'dbi_info_global_tips_store_rank_combine_detail_rank_trend',
    globalWoChianInfoKey: 'dbi_info_global_wo_china_tips_store_rank_mobile_detail',
    disableNoChina: true,
    pageId: 'combine_detail_storerank_region',
  },
  {
    savePopupVisble: 0,
    key: filterKeyMap.TIPICON,
    visibleinlist: 1,
    content: 'dbi_country_flter_applies',
  },
  {
    savePopupVisble: 0,
    key: filterKeyMap.COMPOSED_COUNTRY_SELECT,
    visibleinlist: 1,
    disabled: false,
    isAll: false,
    isShowTypeSelect: false,
    options: [],
    regionsOptionsMap: {},
  },
];

export const COMBINE_STORERANK_RANKTREND_DEFAULT_PARAMS = {
  unified_id: '',
  app_ids: [''],
  entity_type: 'pc',
  source: [
    'steam top sellers',
    'daily steam top 100 players',
    'steam new and trending',
    'steam top wish lists',
  ],
  region_type: 'market',
  regions: ['global'],
  granularity: 'daily',
  start_date: '',
  end_date: '',
  order_source: 'steam top sellers',
  order: 'desc',
  b_last_date: false,
  b_ratio_start_date: false,
};
